import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function fetchInitialConfiguration({ partId, selectionPath }: { partId: string; selectionPath: string }) {
  const response = await occFetch(occUrl("/cad/initialConfig"), {
    body: JSON.stringify({ partId, selectionPath }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  return response.json();
}
